var render = function render(){var _vm=this,_c=_vm._self._c;return _c('master-crud-page',{attrs:{"master":"sensor_category","title":"Sensor Category","access":"master_sensor_category","pk":"mscaId","columns":_vm.columns,"fields":_vm.fields,"filters":_vm.filters}})
}
var staticRenderFns = []

export { render, staticRenderFns }